export const feedbackReasons = [
  'Inaccurate response',
  'Missing information',
  'Tone of voice',
  'Speed of answer',
  'Answer format',
]
